module.exports = __webpack_public_path__ + "static/rv4-26507dcb561706e0e3c697e503e76c67.jpg";